import { useEffect, useState } from 'react';
import './App.css';
import Index from './Views/Index/Index';
import Login from './Views/Login/Login';

function App() {

  const [logged] = useState(true); 
  const [userID, setUserID] = useState(undefined);

  function logOut(){
    localStorage.removeItem("afroditaUser");
    setUserID(undefined)
  }

  function logIn(data){
    setUserID({id: data.id, name: data.username, phone: data.phone, email: data.email});
    localStorage.setItem('afroditaUser', JSON.stringify({id: data.id, name: data.username, phone: data.phone, email: data.email}))
  }

  useEffect(() => {
    setUserID(JSON.parse(localStorage.getItem("afroditaUser")))
    console.log(JSON.parse(localStorage.getItem("afroditaUser")))
  }, [logged])

  return(
    <div>
        {userID === undefined || userID === null ? <Login key={'Login component'} logIn={logIn}/> : <Index key={'Index component'}  userID={userID} logOut={logOut}/>}
    </div>
  )
}

export default App;
